import React, { useState } from "react";
import SidebarTabs from "./SidebarTabs";
import { useAuth } from "../context/AuthContext";
import gsLogo from "../../assets/gs_logo-goktas.svg";
import HeaderProfileMenu from "../common/HeaderProfileMenu";

const MenuIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="#555"
    viewBox="0 0 16 16"
    style={{ cursor: "pointer" }}
  >
    <path
      fillRule="evenodd"
      d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
    />
  </svg>
);

function Layout({
  children,
  hideSidebar = false,
  hideHeader = false,
  fullScreen = false,
  defaultCollapsed = false,
}) {
  const { user, logout } = useAuth();

  // defaultCollapsed true verilirse sidebar kapalı başlar.
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  const handleLogout = () => {
    logout();
    window.location.href = "/login";
  };

  const isSidebarVisible = !hideSidebar && !isCollapsed;
  const SIDEBAR_WIDTH = 240;

  return (
    <div
      style={{
        minHeight: "100vh",
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          bottom: 0,
          width: SIDEBAR_WIDTH,
          zIndex: 1000,
          background: "#fff",
          borderRight: "1px solid #ececf1",
          transform: isSidebarVisible
            ? "translateX(0)"
            : "translateX(-100%)",
          transition: "transform 0.3s ease-in-out",
        }}
      >
        <div
          style={{
            height: "100%",
            overflowY: "auto",
          }}
        >
          <SidebarTabs
            header={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  padding: "24px 20px",
                }}
              >
                <img
                  src={gsLogo}
                  alt="Logo"
                  style={{
                    width: 36,
                    height: 36,
                    background: "#f1f2f6",
                    borderRadius: "50%",
                  }}
                />

                <span
                  style={{
                    fontWeight: 600,
                    fontSize: 18,
                    color: "#283049",
                    whiteSpace: "nowrap",
                  }}
                >
                  Göktaş Portal
                </span>
              </div>
            }
          />
        </div>
      </div>

      {!hideHeader && (
        <header
          style={{
            height: 64,
            background: "#fff",
            borderBottom: "1px solid #ececf1",
            position: "fixed",
            top: 0,
            right: 0,
            left: isSidebarVisible ? SIDEBAR_WIDTH : 0,
            zIndex: 900,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 24px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
            transition: "left 0.3s ease-in-out",
          }}
        >
          <div
            onClick={() => setIsCollapsed((prev) => !prev)}
            style={{ cursor: "pointer" }}
          >
            {!hideSidebar && <MenuIcon />}
          </div>

          <HeaderProfileMenu
            name={user?.name}
            surname={user?.surname}
            onLogout={handleLogout}
          />
        </header>
      )}

      <main
        style={{
          marginTop: hideHeader ? 0 : 64,
          marginLeft: isSidebarVisible ? SIDEBAR_WIDTH : 0,
          padding: "24px",
          background: "#f5f6fa",
          minHeight: fullScreen
            ? "100vh"
            : hideHeader
              ? "100vh"
              : "calc(100vh - 64px)",
          transition: "margin-left 0.3s ease-in-out",
          boxSizing: "border-box",
        }}
      >
        {children}
      </main>
    </div>
  );
}

export default Layout;